import React from 'react'
import { graphql } from 'react-apollo'
import PropTypes from 'prop-types'

import productUsesDefaultModel from '../common/helpers/productUsesDefaultModel'
import getValidDefaultPredictions from './helpers/getValidDefaultPredictions'
import SmartRateDisplay from './SmartRateDisplay'
import SmartRateQuery from './queries/SmartRateQuery'

export const SmartRateWrapper = ({ loanId, parentComponent, businessName, data: { loan = {}, error, loading }, centerText = false }) => {
  const { needsRedecision, lastPredictionDataPermutation, smartRate, predictionResults = [] } = loan
  const [defaultPrediction] = getValidDefaultPredictions(predictionResults.filter(result => result.predictionModel.type === 'default'))
  return (
    <SmartRateDisplay
      businessName={businessName}
      color="blue"
      productUsesDefaultModel={loading || error ? null : productUsesDefaultModel(loan)}
      parentComponent={parentComponent}
      loanId={loanId}
      error={error}
      loading={loading}
      smartRate={smartRate}
      needsRedecision={needsRedecision}
      dataPermutation={lastPredictionDataPermutation}
      defaultProbability={defaultPrediction ? defaultPrediction.riskRating : null}
      centerText={centerText}
    />
  )
}

SmartRateWrapper.propTypes = {
  businessName: PropTypes.string.isRequired,
  data: PropTypes.shape({
    loan: PropTypes.object,
    error: PropTypes.object,
    loading: PropTypes.bool
  }),
  loanId: PropTypes.number.isRequired,
  parentComponent: PropTypes.string
}

export default graphql(SmartRateQuery, {
  options: OwnProps => ({
    variables: {
      loanId: OwnProps.loanId
    }
  })
})(SmartRateWrapper)
